export default {
  default: {
    title: 'No Images Uploaded',
    paragraph:
      'You don’t have any images stored against this project. You can upload images and use them in digital pages to send more information to clients easily.',
  },
}
